export enum ReportType {
    Documents="Documents",
    Products="Products"
}

export enum SignStatus {
    ORDINATA = 1,
    CONSEGNATA = 2,
    DANNEGGIATA = 3,
    RITIRATA = 4,
    IRREPERIBILE = 5,
    ROTTAMATA = 6
}

export enum NET20_AUTHORIZATION {
    READ = "R",
    WRITE = "W"
}

export enum NET20_CONTRACT_TYPE {
    FIRST_CONTRACT = 1,
    RENEWAL = 2,
    NEW_CONTRACT = 3
}

export enum PPE_PRODUCT_TYPE {
    INCLUDED = 1,
    EXCLUDED = 2,
    COST_ALLOCATION = 3
}

export enum PPE_STATUS {
    START_MANAGING = 1,
    TARGET_CHECK = 2,
    IN_PROGRESS = 3,
    EVALUATION_CHECK = 4,
    CLOSED = 5
}

export enum PPE_PDF {
    PROMOTION_PLAN = 1,
    EVALUATION_REPORT = 2
}

export enum PPE_AUTHORIZATION {
    READ = "R",
    WRITE = "W"
}

export enum PPE_UOM {
    KILOS = "KILOS",
    LITERS = "LITERS"
}

export enum PROCESS_TYPE_ENUM {
    uploadPds,
    downloadDocuments,
    sendMails,
    downloadFiles
}
export enum PROCESS_EXECUTION_MODE_ENUM {
    queuing,
    immediate
}
export enum CONTRACT_TYPE_ENUM {
    INTERNAL = 1,
    EXTERNAL = 2,
    OUTER = 3,
}
export enum HTTP_RESPONSE {
    OK = 200,
    UserCreated = 201,
    UserPasswordNotSet = 289,
    DisabledUser = 290,
    TwoFactorRequired = 291,
    InternalUser = 292,
    UserLockedOut = 293,
    UserPasswordExpired = 294,
    InvalidOTPCode = 295,
    InvalidCredentials = 296,
    UserDoesntExist = 297,
    LoginFailed = 298,
    LoggedIn = 299,
    BadRequest = 400,
    NotFound = 404,
    Conflict = 409,
    Unauthorized = 460,
    InternalServerError = 500
}
